import axios from '@/plugins/http.js'

export function fetchEnterpriseResult (slug, params) {
  const api = `/api/v1/stores/${slug}/enterprise-result`
  return axios.get(api, { params })
}
